// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageViewer_wrapper__dz3F9","image":"ImageViewer_image__VTmc+","noAspectRatio":"ImageViewer_noAspectRatio__s++P6"};